// extracted by mini-css-extract-plugin
export const pageTitle = "PageTitle-module--page-title--2VaG5";
export const pageTitleOverlay = "PageTitle-module--page-title-overlay--122ST";
export const pageTitleContainer = "PageTitle-module--page-title-container--1NIxB";
export const pageTitleContent = "PageTitle-module--page-title-content--Gshnu";